import { useEffect } from 'react';
import { useAuth } from './AuthContext';
import LoginForm from './LoginForm';

// Ouverte sur un 401 de l'API (walter:unauthorized) : reconnexion par-dessus la page, sans
// redirection, pour ne pas perdre un formulaire en cours. « Plus tard » ferme la modale ;
// ce qui n'a pas été enregistré reste à l'écran, et la file hors-ligne attend la reconnexion.
export default function ReconnectModal({ onClose }) {
    const { user } = useAuth();

    useEffect(() => {
        const handleEscape = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    return (
        <div className="auth-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="reconnect-title">
            <div className="auth-modal">
                <h2 id="reconnect-title" className="auth-title">{user ? 'Session expirée' : 'Connexion requise'}</h2>
                <p className="auth-subtitle">
                    {user
                        ? 'Reconnectez-vous pour continuer : la page reste telle quelle, rien de ce qui est affiché n\'est perdu.'
                        : 'Cette action nécessite un compte Walter.'}
                </p>
                <LoginForm defaultEmail={user?.email || ''} autoFocusPassword={Boolean(user)} forgotInNewTab />
                <button type="button" className="auth-btn auth-btn--ghost" onClick={onClose}>Plus tard</button>
            </div>
        </div>
    );
}
